export const migrations = {
  0: (state) => {
    // migration clear out device state
    return {
      ...state,
      api: undefined
    }
  }
}
